import React from 'react'

// [system] call type config
const CALL_TYPE_CONFIG = {
  CALL: { label: 'เรียกพนักงาน', color: '#4A9FDB', bg: '#EBF5FB' },
  BILL: { label: 'ขอเช็คบิล',    color: '#3CBF6A', bg: '#EAF8EF' },
  TIP:  { label: 'ให้ทิปออนไลน์', color: '#F5A623', bg: '#FEF6E8' },
}

// [system] inline SVG icons — no font dependency
function IconCall({ color, size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
    </svg>
  )
}

function IconBill({ color, size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="16" y1="13" x2="8" y2="13"/>
      <line x1="16" y1="17" x2="8" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  )
}

function IconTip({ color, size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  )
}

const ICONS = { CALL: IconCall, BILL: IconBill, TIP: IconTip }

// [customer] Popup alert shown on POS when customer calls staff — no auto-close, must dismiss manually
export default function CallStaffAlert({ data, queueCount = 1, onClose, onGoToBill }) {
  if (!data) return null

  const config = CALL_TYPE_CONFIG[data?.callType] || CALL_TYPE_CONFIG.CALL
  const Icon = ICONS[data?.callType] || ICONS.CALL

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ zIndex: 9999, background: 'rgba(0,0,0,0.5)' }}
    >
      <div
        className="d-flex flex-column align-items-center rounded-4 shadow-lg"
        style={{ background: '#fff', minWidth: 340, maxWidth: 420, padding: '36px 32px 28px' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* icon circle */}
        <div
          className="d-flex align-items-center justify-content-center rounded-circle mb-3"
          style={{ width: 88, height: 88, background: config.bg, flexShrink: 0 }}
        >
          <Icon color={config.color} size={44} />
        </div>

        {/* label */}
        <p className="fw-bold mb-1" style={{ fontSize: 22, color: config.color, margin: 0 }}>
          {config.label}
        </p>

        {/* table name — no "โต๊ะ" prefix */}
        <p style={{ fontSize: 15, color: '#6b7280', margin: '6px 0 28px' }}>
          {data.tableName || data.tableId}
        </p>

        {/* queue indicator */}
        {queueCount > 1 && (
          <p style={{ fontSize: 12, color: '#f97316', marginBottom: 12, fontWeight: 600 }}>
            มีการเรียกเพิ่มอีก {queueCount - 1} รายการ
          </p>
        )}

        {/* BILL type — two buttons: go to bill OR just acknowledge */}
        {data.callType === 'BILL' && onGoToBill ? (
          <div className="d-flex gap-2 w-100">
            <button
              className="btn fw-semibold rounded-3 py-2 flex-fill"
              style={{ background: '#f3f4f6', color: '#374151', fontSize: 14 }}
              onClick={onClose}
            >
              รับทราบ
            </button>
            <button
              className="btn fw-semibold rounded-3 py-2 flex-fill"
              style={{ background: config.color, color: '#fff', fontSize: 14 }}
              onClick={() => { onClose(); onGoToBill(data.tableId) }}
            >
              ไปที่รายการ
            </button>
          </div>
        ) : (
          <button
            className="btn w-100 fw-semibold rounded-3 py-2"
            style={{ background: config.color, color: '#fff', fontSize: 15 }}
            onClick={onClose}
          >
            รับทราบ
          </button>
        )}
      </div>
    </div>
  )
}
// =====================[CallStaffAlert]=====================
